import { Component, OnInit, OnDestroy, ViewChild, ViewContainerRef, ComponentRef, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlotsViewVariantService, SlotsViewVariantCode } from '../../shared/services/slots-view-variant.service';
import { Loader } from '../../shared/loader/loader';

@Component({
  selector: 'app-available-slots-wrapper',
  standalone: true,
  imports: [CommonModule, Loader],
  template: `
    <app-loader *ngIf="isLoading" [fullscreen]="true" [message]="'Loading...'"></app-loader>
    <ng-container #variantContainer></ng-container>
  `,
  styles: []
})
export class AvailableSlotsWrapper implements OnInit, OnDestroy {
  @ViewChild('variantContainer', { read: ViewContainerRef, static: true })
  variantContainer!: ViewContainerRef;

  isLoading = true;
  private componentRef: ComponentRef<any> | null = null;

  constructor(private slotsViewVariant: SlotsViewVariantService) {}

  ngOnInit() {
    this.slotsViewVariant.resolveVariant().subscribe((code) => this.loadVariantComponent(code));
  }

  private async loadVariantComponent(code: SlotsViewVariantCode) {
    try {
      const module = code === 'cards'
        ? await import('./../cards/available-slots/default/available-slots')
        : await import('./../scroll/available-slots/default/available-slots');
      const component: Type<any> = module.AvailableSlots;
      this.variantContainer.clear();
      this.componentRef = this.variantContainer.createComponent(component);
      this.isLoading = false;
    } catch (error) {
      console.error(`Failed to load available-slots variant for ${code}:`, error);
      this.isLoading = false;
    }
  }

  ngOnDestroy() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }
  }
}
